// src/pages/SignupPage.js
import React, { useState } from 'react';
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { auth } from '../firebase';
import { useAuth } from '../provider/AuthProvider';
import { useNavigate, Navigate } from 'react-router-dom';
import {Alert, Button, Card, Container, Form} from "react-bootstrap";
import Header from "../components/Header";

function SignupPage() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const { user } = useAuth();
    if (user) return <Navigate to="/" />;

    const handleSignup = async (e) => {
        e.preventDefault();
        try {
            await createUserWithEmailAndPassword(auth, email, password);
            await updateProfile(auth.currentUser, {displayName: name});
            navigate('/');
        } catch (err) {
            alert("Signup failed: " + err.message);
        }
    };

    return (
        <>
        <Header />
        <Container className="d-flex justify-content-center align-items-center min-vh-100">
            <Card style={{ width: '100%', maxWidth: '400px' }} className="p-4 shadow">
                <h2 className="text-center mb-4">Sign Up</h2>
                {error && <Alert variant="danger">{error}</Alert>}
                <Form onSubmit={handleSignup}>
                    <Form.Group controlId="formName" className="mb-3">
                        <Form.Label>What would you like Charlotte to call you?</Form.Label>
                        <Form.Control
                            type="text"
                            value={name}
                            onChange={e => setName(e.target.value)}
                            required
                        />
                    </Form.Group>
                    <Form.Group controlId="formEmail" className="mb-3">
                        <Form.Label>Email address:</Form.Label>
                        <Form.Control
                            type="email"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            required
                        />
                    </Form.Group>
                    <Form.Group controlId="formPassword" className="mb-3">
                        <Form.Label>Password:</Form.Label>
                        <Form.Control
                            type="password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            required
                        />
                    </Form.Group>
                    <Button variant="success" type="submit" className="w-100">
                        Sign Up
                    </Button>
                    <div className="text-center mt-3">
                        <a href="/login">Already have an account? Login</a>
                    </div>
                </Form>
            </Card>
        </Container>
        </>
    );
}

export default SignupPage;

